import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import App from './App';

// Custom color theme with serif font for headings
const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: "'Abyssinica SIL', serif",
    body: "system-ui, sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        color: '#1A1A1A',
      },
      '@media (prefers-reduced-motion: reduce)': {
        '*': {
          animationDuration: '0.01ms !important',
          animationIterationCount: '1 !important',
          transitionDuration: '0.01ms !important',
        },
      },
    },
  },
  colors: {
    // Brand colorScheme — aligned with active green scale
    brand: {
      50:  '#d9f7be',
      100: '#b7eb8f',
      200: '#95de64',
      300: '#73d13d',
      400: '#52c41a',
      500: '#389e0d',
      600: '#237804',
      700: '#135200',
      800: '#092b00',
      900: '#051a00',
      950: '#031200',
    },
    active: {
      50:  '#d9f7be',
      100: '#b7eb8f',
      200: '#95de64',
      300: '#73d13d',
      400: '#52c41a',
      500: '#389e0d',
      600: '#237804',
      700: '#135200',
      800: '#092b00',
      900: '#051a00',
      950: '#031200',
    },
    suggestion: {
      50:  '#f3e8ff',
      100: '#e9d5ff',
      200: '#d8b4fe',
      300: '#c084fc',
      400: '#a855f7',
      500: '#9333ea',
      600: '#7c3aed',
      700: '#6d28d9',
      800: '#5b21b6',
      900: '#4c1d95',
      950: '#2e1065',
    },
    pending: {
      50:  '#bae7ff',
      100: '#91d5ff',
      200: '#69c0ff',
      300: '#40a9ff',
      400: '#1890ff',
      500: '#096dd9',
      600: '#0050b3',
      700: '#003a8c',
      800: '#002766',
      900: '#001529',
      950: '#000e1a',
    },
    inactive: {
      50:  '#f5f5f5',
      100: '#e8e8e8',
      200: '#d9d9d9',
      300: '#bfbfbf',
      400: '#a6a6a6',
      500: '#8c8c8c',
      600: '#737373',
      700: '#595959',
      800: '#404040',
      900: '#262626',
      950: '#0f0f0f',
    },
    // Legacy named tokens kept for reference
    grays: {
      mineShaft: '#323131',
      shiftGray: '#444445',
      boulder: '#807B7B',
      silverChalice: '#AFAFAF',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
